class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    if (!this.detailsContainer) return;
    this.summaryToggle = this.querySelector('summary');
    if (!this.summaryToggle) return;

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );

    if (this.querySelector('button[type="button"]')) {
      this.querySelector('button[type="button"]').addEventListener(
        'click',
        this.close.bind(this)
      );
    }

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (
      (!this.contains(event.target) &&
        !event.target.classList.contains('predictive-search__keyword')) ||
      event.target.classList.contains('modal-overlay')
    )
      this.close(false);
  }

  // The navigation drawer now opens below the header, so .header__search stays
  // clickable while the drawer (or one of its submenus) is showing. Stacking the
  // search modal on top would leave two dialogs fighting over focus and the body
  // scroll lock, so the drawer closes as the modal opens.
  closeMenuDrawer() {
    const details = document.querySelector('#Details-menu-drawer-container');
    if (!details || !details.hasAttribute('open')) return;

    // No focus restore — trapFocus below moves focus into the search input
    // rather than back to the menu button.
    details.closest('menu-drawer')?.closeMenuDrawer(null, false);

    // MenuDrawer releases the body scroll lock on a timer. Ours is queued after
    // it with the same delay, so it runs second and re-locks for this modal.
    setTimeout(() => document.body.classList.add('overflow-hidden'));
  }

  open(event) {
    this.closeMenuDrawer();

    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
